import { BaseSanitizer } from './BaseSanitizer';
export class CreditCardSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'CREDIT_CARD', 'creditCards', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const cardNumberMatches = this.detectCardNumbers(text);
        const cvvMatches = this.detectCVVCodes(text);
        matches.push(...cardNumberMatches, ...cvvMatches);
        return this.removeOverlappingMatches(matches);
    }
    detectCardNumbers(text) {
        const patterns = [
            '\\b(?:\\d[ -]*?){13,16}\\b',
            '\\b\\d{4}[ -]?\\d{4}[ -]?\\d{4}[ -]?\\d{4}\\b'
        ];
        const matches = [];
        for (const pattern of patterns) {
            const regex = new RegExp(pattern, 'g');
            let match;
            while ((match = regex.exec(text)) !== null) {
                const potential = match[0].replace(/[ -]/g, '');
                if (this.isValidCreditCard(potential)) {
                    matches.push({
                        originalText: match[0],
                        tag: '',
                        startIndex: match.index,
                        endIndex: match.index + match[0].length
                    });
                }
            }
        }
        return matches;
    }
    detectCVVCodes(text) {
        const matches = [];
        const patterns = [
            /(?:CVV|CVC|CVV2|CVC2|security code|verification code|card code|cid)\s*(?:is|:|=)?\s*(\d{3,4})\b/gi
        ];
        for (const pattern of patterns) {
            pattern.lastIndex = 0;
            let match;
            while ((match = pattern.exec(text)) !== null) {
                const cvv = match[1];
                if (this.looksLikeCVVContext(text, match.index)) {
                    matches.push({
                        originalText: cvv,
                        tag: '',
                        startIndex: match.index + match[0].indexOf(cvv),
                        endIndex: match.index + match[0].indexOf(cvv) + cvv.length
                    });
                }
            }
        }
        return matches;
    }
    looksLikeCVVContext(text, index) {
        const before = text.substring(Math.max(0, index - 30), index).toLowerCase();
        const after = text.substring(index, Math.min(text.length, index + 20)).toLowerCase();
        const keywords = ['cvv', 'cvc', 'cvv2', 'cvc2', 'security', 'verification', 'card code', 'cid', 'credit card', 'debit card', 'card number'];
        return keywords.some(keyword => before.includes(keyword) || after.includes(keyword));
    }
    isValidCreditCard(number) {
        if (!/^\d{13,16}$/.test(number)) {
            return false;
        }
        let sum = 0;
        let isEven = false;
        for (let i = number.length - 1; i >= 0; i--) {
            let digit = parseInt(number[i], 10);
            if (isEven) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            sum += digit;
            isEven = !isEven;
        }
        return sum % 10 === 0;
    }
}
